import {
  CategoriesWithNoHomePage,
  CategoryConfig,
  HeaderNavOption,
} from "@components/swagmagic/header/type";

import {
  CATEGORY_HOME_LINK_TYPE,
  CATALOG_HOME_LINK_TYPE,
  CATEGORY_PRODUCT_LISTING_LINK_TYPE,
  FILTER_OPTION_VALUE,
  FILTER_OPTIONS_VALUES,
  FILTER_SYNC_QUERY,
} from "@stadium/shared/src/constants/stores/routes";
import { SERVER_PHASE } from "@stadium/constants";
import { BYSTADIUM_HOSTNAME } from "@stadium/helpers/app-routes";
import { ALL_PRODUCTS, ALL_SUBCATEGORY_CODE } from "@constants/routes";

export const getDynamicCatalogNav = ({
  categories,
  categoriesWithNoHomePage,
}: {
  categories: any;
  categoriesWithNoHomePage?: CategoriesWithNoHomePage[];
}) => {
  const catalogCategories = categories
    ?.filter(
      (category) => !(category.code === ALL_PRODUCTS && category.itemCode === ALL_SUBCATEGORY_CODE),
    )
    ?.map((category) => {
      const isListingOnly =
        category.children?.length === 0 ||
        categoriesWithNoHomePage?.some(
          (entry: CategoriesWithNoHomePage) => entry.slug === category.code,
        );
      return {
        id: category.code,
        label: category.name,
        code: category.code,
        linkType: isListingOnly ? CATEGORY_PRODUCT_LISTING_LINK_TYPE : CATEGORY_HOME_LINK_TYPE,
        image: {
          url: category.portraitImage,
          alt: category.name,
        },
        links: category.children?.map((child) => ({
          id: child.code,
          label: child.name,
          code: child.code,
          linkType: CATEGORY_PRODUCT_LISTING_LINK_TYPE,
        })),
        quickLinks: [
          {
            label: `View All ${category.name}`,
            code: category.code,
            linkType: CATEGORY_PRODUCT_LISTING_LINK_TYPE,
            query: FILTER_SYNC_QUERY,
          },
          {
            label: `Sustainable ${category.name}`,
            code: category.code,
            linkType: CATEGORY_PRODUCT_LISTING_LINK_TYPE,
            query: FILTER_OPTIONS_VALUES[FILTER_OPTION_VALUE.SUSTAINABLE],
          },
          {
            label: "Recommended",
            code: category.code,
            linkType: CATEGORY_PRODUCT_LISTING_LINK_TYPE,
            query: FILTER_OPTIONS_VALUES[FILTER_OPTION_VALUE.RECOMMENDED],
          },
          {
            label: "New Arrivals",
            code: category.code,
            linkType: CATEGORY_PRODUCT_LISTING_LINK_TYPE,
            query: FILTER_OPTIONS_VALUES[FILTER_OPTION_VALUE.NEW_ARRIVALS],
          },
          {
            label: "No Minimum",
            code: category.code,
            linkType: CATEGORY_PRODUCT_LISTING_LINK_TYPE,
            query: FILTER_OPTIONS_VALUES[FILTER_OPTION_VALUE.NO_MINIMUM],
          },
        ],
      };
    });

  const dynamicCatalogNav = {
    navOption: {
      title: "Catalog",
      categories: catalogCategories,
      linkType: CATALOG_HOME_LINK_TYPE,
    } as CategoryConfig,
  } as HeaderNavOption;

  return dynamicCatalogNav;
};

export const isActiveNavLink = (pathname: string, linkUrl: string) => {
  let linkPathname = "";
  try {
    linkPathname = new URL(linkUrl, SERVER_PHASE ? BYSTADIUM_HOSTNAME : window.location.origin)
      .pathname;
  } catch {
    linkPathname = "";
  }
  return pathname === linkPathname;
};
